// export const BROKERS = {
//   settrade : 'settrade',
//   bitkub : 'bitkub',
//   globlex : 'globlex'

import { exchangeEnum } from "src/types/local-types"

// }
export const EXCHANGES = {
  bitkub:'BITKUB',
  settrade:'SETTRADE',
  default:'DEFAULT'
}

export const BROKERS = {
  settrade : {
    name : "settrade",
    model : {
      unit : "ช่อง",
      max : 5,
    },
    url : "https://www.globlex.co.th/eserviceweb/?app=stockradars",
    description : "คุณสามารถฝากเงินเข้าบัญชี Globlex ผ่านเว็บไซต์"
  },
  bitkub : {
    name : "bitkub",
    model :  {
      unit : "%",
      max : 10,
    },
    url : "https://www.bitkub.com/deposit",
    description : "คุณสามารถฝากเงินเข้าบัญชีทาง Bitkub ได้เลย"
  },
  globlex : {
    name : "globlex",
    model :  {
      unit : "ช่อง",
      max : 5,
    },
    url : "https://www.globlex.co.th/eserviceweb/?app=stockradars",
    description : "คุณสามารถฝากเงินเข้าบัญชี Globlex ผ่านเว็บไซต์"
  }
}